import { invert } from 'lodash';

import { QUICK_FILTER_TYPE } from '@app/constants';

type DateRangeOptions =
  | typeof QUICK_FILTER_TYPE.pastYear
  | typeof QUICK_FILTER_TYPE.pastFiveYears
  | typeof QUICK_FILTER_TYPE.pastTenYears;

export const getDateRangeOptions = (): {
  options: Record<DateRangeOptions, string>;
  invertedOptions: Record<string, DateRangeOptions>;
} => {
  const currentYear = new Date().getFullYear();

  const options = {
    [QUICK_FILTER_TYPE.pastYear]: `${currentYear - 1}`,
    [QUICK_FILTER_TYPE.pastFiveYears]: `${currentYear - 5}`,
    [QUICK_FILTER_TYPE.pastTenYears]: `${currentYear - 10}`,
  };
  const invertedOptions = invert(options) as Record<string, DateRangeOptions>;

  return { options, invertedOptions };
};
